import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TQcoState } from './qco.models';

export const getQcoState = (state: TMachineMaintenanceState) => state.qcoInfo;

export const getLineSetupTickets = createSelector(getQcoState, (state: TQcoState) => state.lineSetupTicketsListing);

export const getLineSetupSubtasks = createSelector(getQcoState, (state: TQcoState) => state.lineSetupSubtasksListing);

export const getLineSetupNewSetup = createSelector(
  getQcoState,
  (state: TQcoState) => state.lineSetupTicketNewSetupDetails,
);

export const getLineSetupCurrentSetup = createSelector(
  getQcoState,
  (state: TQcoState) => state.lineSetupTicketCurrentSetupDetails,
);

export const getLineSetupPaginationOption = createSelector(
  getQcoState,
  (state: TQcoState) => state.lineSetupTicketPaginationOption,
);
